// extracted by mini-css-extract-plugin
export default {"formContainer":"cityForm_formContainer__A6MRr","formGroup":"cityForm_formGroup__hk92y","submitButton":"cityForm_submitButton__Qsc2W","message":"cityForm_message__iRx6D"};